export default {
	titleRow: { 
		display: 'flex', 
		justifyContent: 'space-between' 
	},

}